import { dec } from "@/lib/formatters";

const latest = (rows) => (rows?.length ? rows[rows.length - 1] : null);
const diffText = (a, b, label) => {
  if (a == null || b == null) return null;
  const d = Math.round((a - b) * 10) / 10;
  return `${dec(Math.abs(d), 1)} år ${d >= 0 ? "eldre" : "yngre"} enn ${label}`;
};

export const AlderBlock = ({ data }) => {
  const k = latest(data?.kommune);
  if (!k) return null;
  const f = data.fylke?.find((r) => r.year === k.year);
  const l = data.land?.find((r) => r.year === k.year);
  return (
    <div className="mt-6 pt-6 border-t border-[#E6E9F0]" data-testid="alder-block">
      <p className="text-xs font-semibold uppercase tracking-[0.1em] text-[#8AA4BF] mb-3">Gjennomsnittsalder {k.year}</p>
      <div className={`grid ${f ? "grid-cols-3" : "grid-cols-2"} gap-2 mb-3`}>
        <div className="p-2 border border-[#E6E9F0] rounded-lg" data-testid="alder-kommune">
          <p className="text-[11px] text-[#8AA4BF]">Kommunen</p>
          <p className="text-2xl font-light text-[#1F2A36]">{dec(k.mean_age, 1)} år</p>
          <p className="text-[11px] text-[#4B647F]">median {k.median_age} år</p>
        </div>
        {f && (
          <div className="p-2 border border-[#E6E9F0] rounded-lg" data-testid="alder-fylke">
            <p className="text-[11px] text-[#8AA4BF]">{data.fylke_name || "Fylket"}</p>
            <p className="text-2xl font-light text-[#3F8A86]">{dec(f.mean_age, 1)} år</p>
            <p className="text-[11px] text-[#4B647F]">median {f.median_age} år</p>
          </div>
        )}
        <div className="p-2 border border-[#E6E9F0] rounded-lg" data-testid="alder-land">
          <p className="text-[11px] text-[#8AA4BF]">Landet</p>
          <p className="text-2xl font-light text-[#6B7280]">{l ? `${dec(l.mean_age, 1)} år` : "—"}</p>
          <p className="text-[11px] text-[#4B647F]">{l ? `median ${l.median_age} år` : ""}</p>
        </div>
      </div>
      <p className="text-xs text-[#4B647F] mb-3" data-testid="alder-diff">
        Innbyggjarane er i snitt {[diffText(k.mean_age, f?.mean_age, "fylket"), diffText(k.mean_age, l?.mean_age, "landet")].filter(Boolean).join(" og ")}.
      </p>
      <a href="#alder" className="text-xs text-[#103766] underline" data-testid="alder-more-link">Sjå barn og eldre per 100 yrkesaktive og aldring framover</a>
      <p className="text-[11px] text-[#8AA4BF] mt-1">Berekna frå ettårig aldersfordeling per 1. januar (105+ blir rekna som 105 år).</p>
    </div>
  );
};

export default AlderBlock;
